import { render, staticRenderFns } from "./FaqForm.vue?vue&type=template&id=d181c8dc&scoped=true&"
import script from "./FaqForm.vue?vue&type=script&lang=js&"
export * from "./FaqForm.vue?vue&type=script&lang=js&"
import style0 from "./FaqForm.vue?vue&type=style&index=0&id=d181c8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d181c8dc",
  null
  
)

export default component.exports